export default "__VITE_ASSET__Cl4rMC$I__"